// Single source of truth for display-formatting a nutrient number: 1 decimal
// place, or a bare integer when the value is whole (e.g. 166.666... -> 166.7, 100 -> 100).
export function formatNutrientValue(val) {
  const n = Number(val || 0);
  if (isNaN(n)) return 0;
  return n % 1 === 0 ? n : Number(n.toFixed(1));
}
